var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticStyle:{"padding":"2rem 0rem"}},[_c('div',{staticClass:"loading"},[_vm._v("登錄資料檢查…")])])
}
var staticRenderFns = []

export { render, staticRenderFns }